<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-1">
      <div class="container">
        <div class="header-body text-center mb-2">
          <div class="row justify-content-center">
            <div class="col-xl-5 col-lg-6 col-md-8 px-5">
              <h1 class="text-white">Bienvenid@!</h1>
              <p class="text-lead text-white">Ingreso a Aplicación Garnet</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
      
    </div>
    <!-- Page content -->
    <div class="container mt--7 pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7">
          <div class="card bg-secondary border-0 mb-0">
            <!--
            <div class="card-header bg-transparent pb-5">
              <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
              <div class="btn-wrapper text-center">
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                  <span class="btn-inner--text">Github</span>
                </a>
                <a href="#" class="btn btn-neutral btn-icon">
                  <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                  <span class="btn-inner--text">Google</span>
                </a>
              </div>
            </div>
            -->
            <div class="card-body px-lg-5 py-lg-5" style="padding-bottom: 1rem !important;">
              <div class="text-center text-muted mb-0">
                <small>Ingrese sus credenciales</small>
              </div>
              <form role="form" @submit.prevent="login">
                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-email-83"
                            placeholder="Email o RUT"
                            type="text"
                            name="Email"
                            :error="getError('Email')"
                            v-validate="'required'"
                            v-model="model.email">
                </base-input>

                <base-input alternative
                            class="mb-3"
                            prepend-icon="ni ni-lock-circle-open"
                            type="password"
                            placeholder="Contraseña"
                            name="Contraseña"
                            :error="getError('Contraseña')"
                            v-validate="'required'"
                            v-model="model.password">
                </base-input>

                <div class="text-center">
                  <base-button type="primary" nativeType="submit" class="my-4">Ingresar</base-button>
                </div>
              </form>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6">
              <router-link to="/recuperar" class="text-light"><small>Recuperar Contraseña</small></router-link>
            </div>
            <div class="col-6 text-right">
              <!--<router-link to="/register" class="text-light"><small>Create new account</small></router-link>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        model: {
          email: '',
          password: '',
          rememberMe: false
        },
        error: null
      };
    },
    methods: {
        login() {
            var vm = this;
            this.firstFormSubmit().then( response => {
                console.log('retorno promesa de validacion', response);
                if( response ){
                  this.$store.dispatch("retrieveToken", {
                      username: this.model.email,
                      password: this.model.password,
                      vm: this
                  })
                  .then(response => {
                      vm.$store.dispatch("retrieveUser").then( response => {
                          console.log('Datos del usuario: ');
                          console.log(response);
                          /**
                           * Codigo para actualizar el Objeto Abilities
                           * 
                           * vm.$ability.update(session.rules)
                           */
                          console.log(response.permissions);
                          let arreglo = [];
                          response.permissions.forEach(element => {
                              arreglo.push({subject: element[1], actions: element[0]});
                          });
                          vm.$ability.update(arreglo);
                      } );
                      this.$router.push({ name: "Ingresar Venta" });
                  })
                  .catch(error => {
                      vm.error = error.response.data;
                      if( error.response.status == 422 ){
                        vm.alertar(vm.error);
                      }else{
                        vm.alertar('Inicio de sesión fallida');
                      }
                      
                  });
                }
            });
            
        },
        alertar(mensaje)
        {
          this.$notify({
            message: mensaje,
            timeout: 5000,
            icon: 'ni ni-circle-08',
            type: 'default'
          });
        },
        async firstFormSubmit() {
            try {
                return await this.$validator.validateAll();
            } catch {
                return false;
            }
            finally {
                this.validated = true;
            }
        },
        getError(name){
            return this.errors.first(name)
        },
        isValid(name) {
            return this.validated && !this.errors.has(name);
        },
    },
    created(){
        console.log(process.env.VUE_APP_API_URL);
        
    }
  };
</script>
<style lang="scss">
    .invalid-feedback {
        text-align: center;
    }
    
    .bg-gradient-success {
      background: linear-gradient(87deg, #248dc1 0, #2dcecc 100%) !important;
     }
     /*
    .bg-default {
      background: linear-gradient(87deg, #248dc1 0, #2dcecc 100%) !important;
    
    }
    */
</style>